var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonAddRow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 486.4 486.4",
    style: {
      enableBackground: "new 0 0 486.4 486.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.5,
    y: 227.6,
    fill: "current",
    width: 70,
    height: 178.9
  })), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M424,192.6h-32.4v70h9.4v108.9H91.9V262.6h201.4v-70H68.9c-25.9,0-47,21.1-47,47v154.9c0,25.9,21.1,47,47,47 H424c25.9,0,47-21.1,47-47V239.6C471,213.7,449.9,192.6,424,192.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M414.4,178.7h-144c-19.3,0-35-15.7-35-35s15.7-35,35-35h144c19.3,0,35,15.7,35,35S433.7,178.7,414.4,178.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M342.4,250.7c-19.3,0-35-15.7-35-35v-144c0-19.3,15.7-35,35-35s35,15.7,35,35v144 C377.4,235.1,361.7,250.7,342.4,250.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonAddRow);
export default __webpack_public_path__ + "static/media/button-add-row.656b8755fb4fb1dd883b08acc5892208.svg";
export { ForwardRef as ReactComponent };